import {Track} from "@/api"

// Track ids listed here are sorted to the bottom of the browse page.
// They stay in the list and remain reachable via /track/<id>.
const DemotedTrackIds: ReadonlySet<string> = new Set<string>([
    "cc11a5e23d4",
])

export const isDemoted = (track: Track): boolean => DemotedTrackIds.has(track.id)
